import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Victim from './components/Victim/Victim.vue'
import Volunteer from './components/Volunteer/Volunteer.vue'
import Donor from './components/Donor/Donor.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   // component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
    {
      path: '/victim',
      name: 'victom',
      component: Victim
    },
    {
      path: '/volunteer',
      name: 'volunteer',
      component: Volunteer
    },
    {
      path: '/donor',
      name: 'donor',
      component: Donor
    }
  ],
});
